import React from 'react';
import './AboutUs.scss';
import { Helmet } from "react-helmet";
import artifitIcon from '../Assets/Images/ArtifitIcon.png';

function AboutUs() {
  return (
    <div className='hero'>
      <Helmet>
        <title>Artifit - About us</title>
        <meta name="description" content="Information about the Artifit company" />
      </Helmet>

      {/* Combined decorative container — moves as one unit */}
      <div className='hero-deco'>
        <img className='hero-bg-icon' src={artifitIcon} alt="" />
      </div>

      <div className='hero-content'>
        <div className='hero-text'>
          <p className='hero-subtitle'>Own the information.</p>
          <h1 className='hero-title'>
            Make the best <span className='hero-title-orange'>decision.</span>
          </h1>
          <h2 className='hero-tagline'>
            Proprietary intelligent<br className='hero-tagline-break' /> technology and services.
          </h2>
          <p className='hero-description'>
            We help organizations unlock business value through data, AI and software solutions. From consulting and strategy to the development of custom applications, we transform complex challenges into scalable digital products that improve efficiency, enhance customer experience, and drive measurable business results.
          </p>
          <div className='hero-cta'>
            <a href="mailto:office@artifit.rs" rel="noreferrer" target="_blank">
              <button className='hero-btn'>Get in touch</button>
            </a>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
